import { render, staticRenderFns } from "./UploadImgss.vue?vue&type=template&id=aa5e0e4c&scoped=true&"
import script from "./UploadImgss.vue?vue&type=script&lang=js&"
export * from "./UploadImgss.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgss.vue?vue&type=style&index=0&id=aa5e0e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5e0e4c",
  null
  
)

export default component.exports